import { useEffect, useState } from 'react'

const ONE_SECOND_MS = 1000

export const useCountdown = (initialSeconds: number) => {
  const [secondsLeft, setSecondsLeft] = useState(initialSeconds)

  useEffect(() => {
    if (secondsLeft <= 0) return
    const tick = setTimeout(
      () => setSecondsLeft((seconds) => seconds - 1),
      ONE_SECOND_MS,
    )
    return () => clearTimeout(tick)
  }, [secondsLeft])

  return { secondsLeft, restart: setSecondsLeft }
}
